import * as React from "react";
import {none, option, Option} from "ts-option";
import Appointment from "../../model/appointment/Appointment";
import AppointmentFormBody from "./AppointmentFormBody";
import AppointmentStatus, {AppointmentStatusEnum} from "../../model/appointment/AppointmentStatus";
import AppointmentType from "../../model/appointment/AppointmentType";
import moment = require("moment");

interface Props {
	/**
	 * Lead identifier
	 */
	leadId: Option<string>;
	/**
	 * Appointment update callback
	 * @param {Appointment} appointment
	 * @param {Option<string>} leadId
	 */
	updateAppointment: (appointment: Appointment, leadId: Option<string>) => void;
	/**
	 * Appointment create callback
	 * @param {Appointment} appointment
	 * @param {Option<string>} leadId
	 */
	createAppointment: (appointment: Appointment, leadId: Option<string>) => void;
	/**
	 * Array of appointments
	 */
	appointments: Option<Appointment[]>
	/**
	 * Indicates that add appointment is possible
	 */
	addAppointmentPossible?: boolean
	/**
	 * Custom class for appointments table.
	 */
	tableCustomClass?: string
	/**
	 * Lead form contact. Needed to show appointment confirmation during lead creation.
	 */
	leadFormContactId: Option<string>;
}

interface State {
	/**
	 * Appointment modal form view visibility
	 */
	appointmentModalVisible: boolean;
	/**
	 * Indicates if data is loading.
	 */
	isLoading: boolean;
	/**
	 * Sales engineer assigned to appointment
	 */
	appointmentSalesEngineerId: Option<string>;
	/**
	 * Init appointment date
	 */
	appointmentDate: Option<moment.Moment>;
	/**
	 * Appointment type
	 */
	appointmentType: Option<AppointmentType>;
	/**
	 * Appointment to edit
	 */
	editedAppointment: Option<Appointment>

}


export default class AppointmentFormView extends React.Component<Props, State> {

	constructor(props: Props) {
		super(props);
		this.state = {
			appointmentModalVisible: false,
			isLoading: props.appointments.isEmpty,
			appointmentDate: none,
			appointmentType: none,
			editedAppointment: none,
			appointmentSalesEngineerId: none,
		};
		this.onEditAppointmentsBtnClick = this.onEditAppointmentsBtnClick.bind(this);
		this.onValueChange = this.onValueChange.bind(this);
	}

	render() {
		return <AppointmentFormBody onAddClick={() => {this.setState({appointmentModalVisible: true})}}
									leadId={this.props.leadId}
									createAppointment={this.props.createAppointment}
									appointments={this.props.appointments}
									updateAppointment={this.props.updateAppointment}
									appointmentModalVisible={this.state.appointmentModalVisible}
									onEditAppointmentsBtnClick={this.onEditAppointmentsBtnClick}
									onClose={() => this.setState(
										{appointmentModalVisible: false, appointmentDate: none, editedAppointment: none})}
									isLoading={this.state.isLoading}
									appointmentToEdit={this.state.editedAppointment}
									onValueChange={this.onValueChange}
									addAppointmentPossible={this.props.addAppointmentPossible}
									tableCustomClass={this.props.tableCustomClass}
									leadFormContactId={this.props.leadFormContactId}/>
	}

	/**
	 * On appointment edit click
	 * @param {Appointment} appointment
	 */
	onEditAppointmentsBtnClick(appointment: Appointment) {
		this.setState({
			appointmentModalVisible: true,
			editedAppointment: option(appointment),
			appointmentDate: option(appointment.dateTime),
			appointmentType: appointment.type,
			appointmentSalesEngineerId: appointment.assigneeId
		})
	};

	/**
	 * On value changed.
	 * @param {Appointment} appointment
	 */
	onValueChange(appointment: Appointment): void {
		if (this.state.editedAppointment.isEmpty)
			this.props.createAppointment(appointment, this.props.leadId);
		else {
			this.props.updateAppointment(
				appointment.copy({status: AppointmentStatus.fromString(AppointmentStatusEnum.Unconfirmed)}),
				this.props.leadId)
		}
	}

}